<mat-card appearance="outlined" class="mat-card">
  <mat-card-title class="mat-headline-6 text--primary">{{ title }}:</mat-card-title>
  <mat-card-content>
    <br />
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
